<ng-container *ngIf="config?.skipAclCheck || (menuGuards && (menuGuards[config?.id] | async))">
  <div
    class="sub-menu-item-wrapper"
    [ngClass]="{
      active: (activeSecondaryNavMenuId$ | async) === config.id,
      'has-tertiary-nav-items': config?.subMenuItems?.length > 0
    }"
     (click)="config?.route ? navigate(config.route) : config?.href ? navigateAway(config.href) : null"
     (keydown.Enter)="navigate(config.route)"
     tabIndex="0"
     (keydown.ArrowLeft)="clearSelectedPrimaryNavConfig()">
     <span class="sub-menu-item" [id]="selectedPrimaryNavConfigId + '-' + config.id">
      {{ config.label }}
    </span>
  </div>
</ng-container>

<ng-container>
  @for(tertiaryNavItem of config?.subMenuItems; track tertiaryNavItem) {
    <app-infopost-sidebar-nav-tertiary-item
    [config]="tertiaryNavItem"
    [selectedPrimaryNavConfigId]="selectedPrimaryNavConfigId"
    [selectedSecondaryNavConfigId]="config.id"
  ></app-infopost-sidebar-nav-tertiary-item>
  }
</ng-container>
